<template>
    <div class="MeusCursos">
        <Header></Header>

        <template v-if="lstCursosRecentes.length > 0">
            <div class="container mt-3">
                <div class="cursos-recentes">
                    <div class="row">
                        <div class="col-12">
                            <span class="txt-p txt-w-5 txt-size-18 txt-grey-3">Cursos recentes</span>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12" v-for="(item,index) in lstCursosRecentes" :key="index">
                            <div class="box-curso-recente" >
                                <div class="row">
                                    <div class="col-12 col-lg-6" style="padding: 20px 30px;">

                                        <span class="txt-p txt-size-14 txt-w-7" style="color: #15C26B;">
                                            {{item.nmCategoria}}
                                        </span>

                                        <p class=" txt-size-20 txt-w-7 txt-grey-3 mb-2">
                                            {{item.nmTreinamento}}
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 txt-grey-3">
                                            {{item.dsTreinamento}}
                                        </p>

                                        <!-- NOTA -->
                                        <Estrelas :nota="item.nota"></Estrelas>

                                        <!-- PERCENTUAL -->
                                        <Progress class="mt-2" :percentual="item.percentualAssistido"></Progress>

                                    </div>
                                    <div class="col-12 col-lg-6 mt-3 mt-md-0 d-none d-lg-flex justify-content-end align-items-center img-curso">
                                        <div class="w-100 h-100 position-relative">
                                            <img class="img" :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)"  onerror="this.onerror=null; this.src='/img-default-curso.png'"  />
                                        </div>
                                        
                                        <router-link class="btn bg-blue-5 txt-white py-3 me-3" :to="{name:'Assistir', params:{id:item.idTreinamento}}">
                                            Continuar curso
                                        </router-link>
                                    </div>
                                    <div class="col-12 col-lg-6 mt-3 mt-md-0 d-block d-lg-none">
                                        <div class="d-grid p-3">
                                            <router-link class="btn bg-blue-5 txt-white py-3 me-3" :to="{name:'Assistir', params:{id:item.idTreinamento}}">
                                                Continuar curso
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="content-view">
            <template v-if="lstMeusCursos.length > 0">
                <div class="container mt-3">
                    <div class="cursos-recentes">
                        <div class="row">
                            <div class="col-12 txt-blue-3">
                                <i class="fas fa-list-ul"></i>
                                <span class="ms-2 txt-p txt-size-20 txt-w-7">Meus cursos</span>
                            </div>

                        </div>
                        <div class="row my-4">
                            <div class="col-8">
                                <span class="txt-p txt-w-5 txt-size-18 txt-grey-3">
                                    Todos os meus cursos
                                </span>
                            </div>
                            <div class="col-4">
                                <div class="input-group">
                                    <input v-model="termoMeusCursos" type="text" class="form-control" placeholder="Buscar nos seus cursos" aria-label="Buscar nos seus cursos" aria-describedby="basic-addon2">
                                    <span class="input-group-text bg-white txt-grey-3" id="basic-addon2"><i class="fas fa-search"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6 col-md-4 col-lg-3 mb-3" v-for="(item,index) in filtroMeusCursos()" :key="index">
                                
                                    <div class="box-curso h-100">
                                        <button v-if="item.flPago" class="btn btn-danger btn-remover-curso" @click="confirmRemover(item.idUsuarioTreinamento)">
                                            <i class="fas fa-times"></i>
                                        </button>
                                        <img class="img-fluid" :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" />
                                        <div class="conteudo p-3 pt-4">
                                            <router-link :to="{name:'Assistir', params:{id:item.idTreinamento}}" class="h-100">
                                                <div class="position-relative">
                                                    <div class="titulo-cursos  p-1  w-100">
                                                        <span class="txt-p txt-size-12 txt-w-7 txt-grey-3 reduz-texto-2">
                                                            {{item.nmTreinamento}}
                                                        </span>
                                                    </div>
                                                </div>

                                                <span class="mt-5 txt-p txt-w-7 txt-size-10 txt-cores-3" v-if="item.flPago">
                                                    Curso gratuito
                                                </span>

                                                <P class="descricao-curso txt-p txt-w-5 txt-size-12 txt-grey-3 mb-1 reduz-texto-2">
                                                    {{item.dsTreinamento}}
                                                </P>
                                                <!-- NOTA -->
                                                <Estrelas :nota="item.nota"></Estrelas>

                                                <!-- PERCENTUAL -->
                                                <Progress class="mt-2" :percentual="item.percentualAssistido"></Progress>
                                            </router-link>
                                        </div>

                                    </div>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="flBusca">
                <div class="row justify-content-center bg-nenhum-curso py-3 mb-3">
                    <div class="col-4 text-center">
                        <p class="txt-p txt-w-8 txt-grey-3 txt-20 mb-3">
                            Você ainda não possui nenhum curso.
                        </p>
                        <p class="txt-p txt-w-5 txt-grey-3 txt-18 mb-0">
                            Por favor, visite a estante de cursos e adquira o conteúdo que desejar.
                        </p>
                        <p class="txt-p txt-w-5 txt-grey-3 txt-18 mb-3">
                            Todos os cursos adquiridos apareceram aqui na sua biblioteca.
                        </p>
                        <router-link class="btn bg-blue-4 txt-white" :to="{name:'Estante'}">
                            IR PARA ESTANTE DE CURSOS
                        </router-link>
                    </div>
                </div>
            </template>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Progress from '@/components/Progress'
    import Estrelas from '@/components/Estrelas'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'

    export default {
        name: 'MeusCursos',
        components: { Header, Footer, Progress, Estrelas },
        data: function () {
            return {
                lstMeusCursos: [],
                lstCursosRecentes: [],

                termoMeusCursos: "",
                flBusca: false,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },

        },
        
        methods: {

            filtroMeusCursos() {
                let $this = this;
                if ($this.termoMeusCursos.toLowerCase() != "") {
                    return $this.lstMeusCursos.filter(function (item) {
                        return item.nmTreinamento.toLowerCase().indexOf($this.termoMeusCursos.toLowerCase()) != -1 || item.dsTreinamento.toLowerCase().indexOf($this.termoMeusCursos.toLowerCase()) != -1;
                    });
                } else {
                    return $this.lstMeusCursos;
                }
            },
            
            load() {
                this.lstMeusCursos = [];
                this.getMeusCursos();
            },

            getMeusCursos() {
                let $this = this;
                axios.get(`${urlApi}/UsuarioTreinamento/MeusCursos`, { params: { termo: $this.termoMeusCursos} })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i].treinamento;

                                    item.nota = res.data.data.rows[i].avaliacao.nota;
                                    item.qtdAvaliacoes = res.data.data.rows[i].avaliacao.qtdAvaliacoes;

                                    /*
                                     {
                                        idCurso: 1,
                                        flPago: true,
                                        nmCurso: 'Seminário Nacional de Orçamento de Obras Públicas',
                                        dsCurso: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget dolor ullamcorper pulvinar imperdiet porttitor. Aliquam dolor, ipsum sodales orci. Consectetur mi malesuada tellus tristique.',
                                        nota: 5,
                                        percentualAssistido: 75,
                                        urlImagem: 'https://picsum.photos/1980/980',
                                    },
                                    */

                                    $this.lstMeusCursos.push(item);
                                }
                                $this.getCursosRecentes();
                                $this.flBusca = true;
                            }
                        } else {
                            $this.flBusca = true;
                            avisoErro("Não foi possível carregar os cursos");
                        }
                    })
                    .catch(function () {
                        $this.flBusca = true;
                        avisoErro("Não foi possível carregar os cursos");
                    });
            },

            getCursosRecentes() {
                let $this = this;
                axios.get(`${urlApi}/UsuarioTreinamento/CursosRecentes`, { params: { take: 1, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                this.lstCursosRecentes = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i].treinamento;

                                    item.nota = res.data.data.rows[i].avaliacao.nota;
                                    item.qtdAvaliacoes = res.data.data.rows[i].avaliacao.qtdAvaliacoes;

                                    $this.lstCursosRecentes.push(item);
                                }

                                if ($this.lstCursosRecentes.length == 0 && $this.lstMeusCursos.length > 0) {
                                    $this.lstCursosRecentes.push($this.lstMeusCursos[0]);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os cursos recentes");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os cursos recentes");
                    });
            },

            confirmRemover(idCurso) {
                let $this = this;
                Swal.fire({
                    icon: 'question',
                    title: 'Confirma a exclusão deste curso?',
                    showDenyButton: true,
                    confirmButtonColor: '#198754',
                    confirmButtonText: 'Sim',
                    denyButtonText: `Não`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        $this.removerCurso(idCurso);
                    }
                })
            },

            removerCurso(idUsuarioTreinamento) {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamento/Delete`, { idUsuarioTreinamento: idUsuarioTreinamento })
                    .then(function(){
                        $this.load();
                    })
                    .catch(function () {
                        avisoErro("Não foi possível remover o curso");
                    });
            },
        },
        created: function () {
            this.load();
            // LOG ACESSO PRODUTO
            axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': 'SC' });
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .bg-nenhum-curso {
        background: #F1F1F1;
        
    }

    .content-view {
        min-height: 45.7vh;
    }

    .box-curso-recente {
        background: #FFFFFF;
        border: 3px solid #A6A6A6;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-position: right !important;

        .img-curso {
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 0 10px 10px 0;
            position: relative;

            .img {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                clip-path: polygon(100% 0%, 100% 100%, 0% 100%, 25% 0%);
                border-radius: 0 7px 7px 0;
            }

            .btn {
                position: absolute;
            }
        }
    }

    .box-curso {
        background: #FFFFFF;
        border: 3px solid #A6A6A6;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        /*height: 300px;*/
        position: relative;

        .btn-remover-curso {
            display: none;
            position: absolute;
            padding: 0px 5px;
            right: 2px;
            top: 2px;
        }

        

        .img-fluid {
            box-sizing: border-box;
            border-radius: 7px;
            height: 125px;
            width: 100%;
        }

        .conteudo {
            padding: 10px;

            .titulo-cursos {
                text-align: center;
                background: #FFFFFF;
                box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
                border-radius: 5px;
                position: absolute;
                top: -50px;
                display: flex;
                align-items: center;
                align-content: center;
                justify-content: center;
                height: 44px;
            }

            .descricao-curso {
                height: 36px;
                display: flex;
                align-items: center;
            }
        }
    }
    .box-curso:hover {
        .btn-remover-curso {
            display: block;
        }
    }

    @media (min-width: 0px) and (max-width: 991.98px) {
        .box-curso-recente {
            background: #FFFFFF !important;
        }
    }
</style>

